export type Palette = readonly string[];

export interface HalftoneData {
  w: number;
  h: number;
  n: number;
  x: Float32Array;
  y: Float32Array;
  r: Float32Array;
  colorIndex: Uint8Array;
  colors: Palette;
  /** Each dot's opacity, 0 to 1. Without it, every dot is opaque. The face's and the
      butterfly's dots fade out at the print's outline (`outlineFade`). */
  opacity?: Float32Array;
}

export interface HalftoneHeader {
  w: number;
  h: number;
  n: number;
  colors: Palette;
}

export type DotGroups = Record<string, Uint32Array>;

/** The most palette colors the face, lens, and butterfly shaders can hold (uniform arrays). */
export const PALETTE_SIZE = 22;

/** The order of the binary's sections. The bake and the loader have to agree on it. */
export const HALFTONE_BYTE_LAYOUT = {
  floats: ["x", "y", "r"],
  u8: "colorIndex",
} as const;

/** The byte length of the little-endian float32 section for `n` dots. It comes from
    `HALFTONE_BYTE_LAYOUT`, so the bake and the loader can't quietly disagree. */
export function halftoneFloatBytes(n: number): number {
  return n * HALFTONE_BYTE_LAYOUT.floats.length * Float32Array.BYTES_PER_ELEMENT;
}

/** The whole .bin file's byte length for `n` dots: the float32 section plus one `colorIndex`
    byte per dot. */
export function halftoneBinByteLength(n: number): number {
  return halftoneFloatBytes(n) + n;
}
